import $ from 'jquery';

$(function () {
  $(document).on('click', '#shareButton', function() {
    let url = $('#copyBtnUrl').val();
    let msgSuccess = $('.share-copied-success');

    navigator.clipboard.writeText(url);
    msgSuccess.css('display', 'block');

    // Hide msg after 2s
    setTimeout(function () {
      msgSuccess.css('display', 'none');
    }, 1500);
  });

  $(document).on('click', '#printButton', function() {
    window.print();
  });

  $(document).on('click', '#printButtonMobile', function() {
    window.print();
  });
});
